module.exports = __webpack_public_path__ + "static/media/bonusSpins_30_40.312bc28a.png";